<ng-container *transloco="let t">
  <helsana-price-calculator-main
    [componentType]="componentType()"
    [portalBaseUrl]="portalBaseUrl()"
    [productConfig]="productConfig()"
    [language]="language()"
    [promosUrl]="promosUrl()"
    [doctorSearchPath]="doctorSearchPath()"
    [tooltipContent]="tooltipContent()"
    [speechBubbleDirection]="speechBubbleDirection()"
  >
  </helsana-price-calculator-main>
</ng-container>
